import { render } from "./Priority.vue?vue&type=template&id=7dbebf2a&scoped=true"
import script from "./Priority.vue?vue&type=script&lang=js"
export * from "./Priority.vue?vue&type=script&lang=js"

import "./Priority.vue?vue&type=style&index=0&id=7dbebf2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbebf2a"]])

export default __exports__